import { useEffect, useState } from "react";
import MenuDrawer from "../../../components/MenuDrawer";
import AppBar from "../../../components/AppBar";
import { Box, Grid, Typography } from "@mui/material";
import DataGridTable from "../../../components/DataGridTable";
import axiosInstance, { BASE_URL } from "../../../constants/config";
import { useSelector } from "react-redux";

const SupervisorDashboard = () => {
  const { userData } = useSelector((state) => state.user);
  const [, setloading] = useState(false);

  const [allPatients, setallPatients] = useState([]);
  const [allActivities, setallActivities] = useState([]);

  const GetAllActivities = async () => {
    setloading(true);
    await axiosInstance
      .get(
        `${BASE_URL}/activity/getAllActivityByCustomerId?customerId=${userData?.customerId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setallActivities(res.data?.allFormsAndActivities);
      })
      .catch((e) => {
        setloading(false);
      });
  };

  const GetPatients = async () => {
    setloading(true);
    await axiosInstance
      .get(
        `${BASE_URL}/user/getAllPatientAndActivity?siteId=${userData?.siteId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setallPatients(res.data?.allPatientsAndActivity);
      })
      .catch((e) => {
        setloading(false);
      });
  };
  const [oneSite, setOneSiteData] = useState([]);

  const GetOneSiteDetail = async () => {
    setloading(true);
    await axiosInstance
      .get(`${BASE_URL}/site/getSiteDetails?siteId=${userData?.siteId}`, {
        withCredentials: true,
      })
      .then((res) => {
        setloading(false);
        setOneSiteData(res.data?.oneSite);
      })
      .catch((e) => {
        setloading(false);
      });
  };
  console.log(oneSite);
  // const { formsData } = useSelector((state) => state.supervisor);

  // const filteredForms = formsData?.filter((val) => {
  //   return val?.form?.status === (activeSwitch ? "active" : "inactive");
  // });
  // const { userData, userRole } = useSelector((state) => state.user);
  //const { allDoctors } = useSelector((state) => state.supervisor);
  const [allDoctors, setAllDoctors] = useState([]);

  const GetAllDoctors = async () => {
    setloading(true);
    await axiosInstance
      .get(
        `${BASE_URL}/user/getDoctorsByCustomerId?customerId=${userData?.customerId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setAllDoctors(res.data?.allUsers);
      })
      .catch((e) => {
        setloading(false);
      });
  };

  useEffect(() => {
    // dispatch(getAllFormsForSupervisor(userData?.siteId));
    GetAllActivities();
    GetOneSiteDetail();
    GetAllDoctors();
    GetPatients();
    // dispatch(getAllSupervisorForAdmin(userData?.customerId));
    //    dispatch(getAllDoctorsForSupervisor(userData?.siteId));

    // GetAllSiteForms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer supervisor />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title="Dashboard" />
        {/* Data Grids */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12}>
            <Box bgcolor="#fff" width="100%" sx={{ borderRadius: "20px" }}>
              {oneSite && oneSite.length !== 0 ? (
                <DataGridTable
                  title="Assigned Site"
                  type="assignedSite"
                  rowData={oneSite || []}
                  pageSize={5}
                  access={true}
                />
              ) : (
                <Typography>No Site Assigned.</Typography>
              )}
            </Box>
          </Grid>

          {/* Doctors Box */}
          <Grid item xs={12} md={6}>
            <Box
              bgcolor="#fff"
              sx={{ borderRadius: "20px" }}
              width="100%"
              mr={2}
            >
              <DataGridTable
                title="Providers"
                type="doctors"
                rowData={allDoctors || []}
                pageSize={5}
                access={true}
              />
            </Box>
          </Grid>
          {/* Patients Box */}
          <Grid item xs={12} md={6}>
            <Box bgcolor="#fff" width="100%" sx={{ borderRadius: "20px" }}>
              <DataGridTable
                title="Patients"
                type="employees"
                rowData={allPatients || []}
                pageSize={5}
                access={true}
              />
            </Box>
          </Grid>

          {/* Forms Box */}
          <Grid item xs={12} md={12}>
            <Box bgcolor="#fff" sx={{ borderRadius: "20px" }} width="100%">
              <DataGridTable
                title="Activities"
                type="forms"
                rowData={allActivities || []}
                pageSize={5}
                access={true}
              />
            </Box>
          </Grid>

          {/* Fourth Box */}
          {/* <Grid item xs={12} md={6}>
            <Box bgcolor="#fff" sx={{ borderRadius: "20px" }} width="100%">
              <DataGridTable
                title="Activity"
                type="activity"
                rowData={dummyActivitiesData}
                pageSize={5}
                access={true}
              />
            </Box>
          </Grid> */}

          {/* Fifth Box */}
          {/* <Grid item xs={12} md={6}>
            <Box bgcolor="#fff" sx={{ borderRadius: "20px" }} width="100%">
              <DataGridTable
                title="Questions"
                type="activity"
                rowData={questionsRows}
                pageSize={5}
                access={true}
              />
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
};

export default SupervisorDashboard;
